import { render, staticRenderFns } from "./ManagerCommentsSection.vue?vue&type=template&id=5f787cc4&scoped=true&"
import script from "./ManagerCommentsSection.vue?vue&type=script&lang=js&"
export * from "./ManagerCommentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ManagerCommentsSection.vue?vue&type=style&index=0&id=5f787cc4&lang=scss&scoped=true&"
import style1 from "./ManagerCommentsSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f787cc4",
  null
  
)

export default component.exports